









import Component from 'vue-class-component'
import {Prop} from "vue-property-decorator";
import BasicComponent from "@/global/BasicComponent";

/*
 * Depcrecated in favor of stripe elements
 */
@Component({
  components: {}
})
export default class SOFORTPayment extends BasicComponent {

  @Prop(Boolean) opened!: boolean;
  @Prop(Boolean) formDataValid!: boolean;
  @Prop(String) firstName: string;
  @Prop(String) lastName: string;

  get dataValid() {
    return this.firstName.length > 0 && this.lastName.length > 0;
  }

  mounted() {

  }

}

